import { render } from "./GenerateAdditionalReport.vue?vue&type=template&id=66ce5a14&scoped=true"
import script from "./GenerateAdditionalReport.vue?vue&type=script&lang=js"
export * from "./GenerateAdditionalReport.vue?vue&type=script&lang=js"

import "./GenerateAdditionalReport.vue?vue&type=style&index=0&id=66ce5a14&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ce5a14"]])

export default __exports__